const AntiPassBack = Object.freeze({
    neutral: "Neutral",
    entry: "Entry",
    exit: "Exit",
  
    /**
     * Returns a <code>InputType</code> enum value from a JavaScript object name.
     * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/InputType} The enum <code>InputType</code> value.
     */
    constructFromObject: function(object) {
      return object;
    }
});

export default AntiPassBack;